<template>
  <v-row>
    <v-col xl="6" lg="6" md="8" sm="12">
      <v-card class="m-2">
        <v-card-text>
          <v-row>
            <v-col sm="4" md="2">
              <v-subheader class="c-label">Name</v-subheader>
              <v-subheader class="c-label">Gesperrt</v-subheader>
              <v-subheader class="c-label">VP-intern</v-subheader>
              <v-subheader class="c-label">VP-extern</v-subheader>
              <v-subheader class="c-label">OB-Kontenführung</v-subheader>
              <v-subheader class="c-label">Mengeneinheit</v-subheader>
              <v-subheader class="c-label">Kostenart</v-subheader>
            </v-col>
            <v-col>
              <v-text-field
                  class="hide-label"
                  v-model="arti.name"
                  :rules="rules.name"
                  counter
                  maxlength="50"
                  hint="Der Name der Leistungsgruppe"
                  label="Name"
                  @input="$emit('change', arti.id)"
              ></v-text-field>
              <v-select
                  class="hide-label"
                  :items="selects"
                  v-model="arti.blocked"
                  label="Gesperrt"
                  hint="Ein gesperrter Artikel wird nicht mehr angezeigt"
                  @input="$emit('change', arti.id)"
              ></v-select>
              <v-text-field
                  class="hide-label"
                  v-model="arti.transfer_price_int"
                  :rules="rules.price"
                  counter
                  maxlength="16"
                  hint="Der interne Verrechnungspreis des Artikels"
                  label="VP-intern"
                  @input="$emit('change', arti.id)"
                  suffix="€"
              ></v-text-field>
              <v-text-field
                  class="hide-label"
                  v-model="arti.transfer_price_ext"
                  :rules="rules.price"
                  counter
                  maxlength="16"
                  hint="Der externe Verrechnungspreis des Artikels"
                  label="VP-extern"
                  @input="$emit('change', arti.id)"
                  suffix="€"
              ></v-text-field>
              <v-text-field
                  class="hide-label"
                  v-model="arti.vr_kost_ein"
                  counter
                  maxlength="50"
                  hint="OB-Kontenführung des Artikels"
                  label="OB-Kontenführung"
                  @input="$emit('change', arti.id)"
              ></v-text-field>
              <v-select
                  class="hide-label"
                  :items="units"
                  v-model="arti.unit"
                  label="Mengeneinheit"
                  hint="Die Einheit des Artikels"
                  @input="$emit('change', arti.id)"
              ></v-select>
              <v-text-field
                  class="hide-label"
                  v-model="arti.cost_type"
                  counter
                  maxlength="50"
                  hint="Die Kostenart des Artikels"
                  label="Kostenart"
                  @input="$emit('change', arti.id)"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "arti_detail",
  props:{
    item: {
      type: Object,
      default: () => {
        return {
          id: '',
          bis_id: '',
          name: '',
          access: '',
          blocked: '',
          unit: '',
          transfer_price_int: '0,00',
          transfer_price_ext: '0,00',
          cost_type: '',
          vr_kost_ein: '',
        }
      }
    },
    artis: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      arti: {
        id: '',
        bis_id: '',
        name: '',
        access: '',
        blocked: '',
        unit: '',
        transfer_price_int: '0,00',
        transfer_price_ext: '0,00',
        cost_type: '',
        vr_kost_ein: '',
      },
      canEdit: false,
      rules: {
        name: [val => (val || '').length > 0 || '*erforderlich'],
        price: [
          value => !!value || '*erforderlich',
          value => {
            const pattern = /^\d+(,\d{1,2})?$/
            return pattern.test(value) || 'Die Eingabe muss im Format 0,00 sein.'
          },
        ],
      },
      selects: [{text: "Ja", value: true}, {text: "Nein", value: false}],
      units: [
          {text: "Sti", value: "Sti"}, {text: "l", value: "l"},
          {text: "cm", value: "cm"}, {text: "m", value: "m"},
          {text: "kg", value: "kg"}, {text: "t", value: "t"},
          {text: "Stck", value: "Stck"}, {text: "km", value: "km"},
          {text: "mm", value: "mm"}, {text: "m²", value: "m²"},
      ],
    }
  },
  watch: {
    item: {
      handler: function (newVal) {
        this.arti = {...newVal};
        this.arti.transfer_price_int = this.arti.transfer_price_int.replace('EU', '').replace('€', '').trim()
        this.arti.transfer_price_ext = this.arti.transfer_price_ext.replace('EU', '').replace('€', '').trim()

      },
      deep: true
    },
  },
  mounted() {
    this.canEdit = this.$cookies.get("ps_username") === 'admin';
    this.arti = {...this.item};
    this.arti.transfer_price_int = this.arti.transfer_price_int.replace('EU', '').replace('€').trim()
    this.arti.transfer_price_ext = this.arti.transfer_price_ext.replace('EU', '').replace('€').trim()

  },
  methods: {
    isValid() {
      return this.arti.name.trim().length > 0;
    },
    resetEdit() {
      this.arti = {...this.item};
    },
    getData() {
      return this.arti;
    }
  }
}
</script>

<style scoped>
::v-deep .theme--light.v-input--is-disabled input {
  color: rgba(0, 0, 0, 0.86);
}

::v-deep .hide-label {
  padding-top: 0px !important;
}

::v-deep .hide-label .v-label {
  display: none !important;
}

.c-label {
  margin-bottom: 10px;
  color: black;
  font-size: 14px;
  font-weight: 500;
}
</style>
